// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"NewsList_ProseMirror__2wyUQ","list":"NewsList_list__2OGpT"};